<style lang='less' scoped>
.custom-tree-node {
   width: calc(100% - 42px);
   height: 40px;
   line-height: 40px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   justify-items: center;
   &__label {
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
   }
}
/deep/ .el-tree-node__content {
   height: 40px;
}
</style>
<template>
   <el-tree
      highlight-current
      ref="tree"
      :data="data"
      :node-key="setProps.id"
      :props="setProps"
      @node-click="nodeClick"
   >
      <template #default="{ node, data }">
         <div class="custom-tree-node">
            <div class="custom-tree-node__label">
               <el-tooltip
                  :open-delay="1000"
                  effect="dark"
                  :content="node.label"
                  placement="top-start"
               >
                  <span> {{ node.label }} </span>
               </el-tooltip>
            </div>
            <el-dropdown v-if="!('disabled' in data && data.disabled)">
               <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
               </span>
               <template #dropdown>
                  <el-dropdown-menu>
                     <slot name="func" :node="node" />
                  </el-dropdown-menu>
               </template>
            </el-dropdown>
         </div>
      </template>
   </el-tree>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, ref, Ref, computed } from "vue";
interface Prop {
   label?: string;
   id?: string | number | null;
   children?: string;
   disabled?: boolean;
   isLeaf?: boolean;
}
export default defineComponent({
   emits: ["handleNode"],
   props: {
      /**
       * @param {Array} data 树数据列表
       */
      data: {
         type: Array as PropType<any[]>,
         default: (): any[] => [],
      },

      /**
       * 同element tree 一样
       */
      props: {
         type: Object as PropType<Prop>,
         default: (): Prop => {
            return {};
         },
      },
   },
   setup(props, ctx) {
      const tree: Ref<null> = ref(null);
      const setProps = computed(
         (): Prop => {
            let defaultProps: Prop = {
               label: "label",
               id: "id",
               children: "children",
            };
            return Object.assign({}, defaultProps, props.props);
         }
      );

      const nodeClick = (data: any): void => {
         ctx.emit("handleNode", data);
      };

      const setCurrentNode = (node: any): void => {
         (tree.value as any).setCurrentNode(node);
      };

      const getCurrentNode = (node: any): any => {
         return (tree.value as any).getCurrentNode();
      };

      return {
         tree,
         setProps,
         nodeClick,
         setCurrentNode,
         getCurrentNode,
      };
   },
});
</script>
